<template>
  <v-container>
    <v-layout row wrap class="mb-5">
      <v-flex xs12 md12>
        <v-layout align-center>
          <h1 class="primary--text mr-3">Partners</h1>
          <v-btn small depressed color="accent" to="/agencies/create">
            <v-icon small>add</v-icon>Create Partner
          </v-btn>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Search" single-line></v-text-field>
        </v-layout>
      </v-flex>
    </v-layout>

    <app-alert
      class="mb-3"
      type="success"
      message="Partner successfully created."
      v-if="$route.query.agencyCreated"
    />
    <!-- <app-alert class="mb-3" type="success" :message="agency.updated" /> -->

    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">
            <span v-if="search !== ''">Results for "{{ search }}"</span>
            <span v-else>All Partners</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="agencies"
            :loading="agenciesLoading"
            :search="search"
            :rows-per-page-items="[30, 60, 100]"
            no-data-text="No Partners available in the database"
          >
            <template v-slot:items="props">
              <td> {{ (props.index + 1) }} </td>
              <td v-if="agency.editing === props.item._id">
                <v-text-field
                  label="Name"
                  type="text"
                  v-model="agency.cached.name"
                  @input="agency.canSave = true"
                ></v-text-field>
              </td>
              <td v-else>{{ props.item.name }}</td>

              <td v-if="agency.editing === props.item._id">
                <v-select
                  v-model="agency.cached.tag"
                  :items="agencyTypeOptions"
                  @input="agency.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                {{ $lang(props.item.tag) }}
              </td>

              <td v-if="agency.editing === props.item._id">
                <v-select
                  v-model="agency.cached.status"
                  :items="statusOptions"
                  @input="agency.canSave = true"
                ></v-select>
              </td>
              <td v-else>
                <v-chip
                  small
                  :color="props.item.status === 'active' ? 'green' : 'red'"
                  text-color="white"
                >{{ $lang(props.item.status) }}</v-chip>
              </td>

              <td v-if="agency.editing === props.item._id">
                <v-btn
                  small
                  depressed
                  color="success"
                  @click="updateAgency()"
                  :disabled="agency.isSaving || !agency.canSave"
                >Save</v-btn>
                <v-btn small flat @click="cancelEdit()" :disabled="agency.isSaving">Cancel</v-btn>
              </td>
              <td v-else>
                <v-icon small class="mr-2" @click="editMode(props.item)">edit</v-icon>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { AGENCY_FETCH, AGENCY_UPDATE } from '@/store/actions/agency'
import { statusOptions, agencyTypeOptions } from '@/data/options'

export default {
  name: 'Agencies',
  created () {
    this.agenciesLoading = true
    this.$store.dispatch(AGENCY_FETCH)
      .finally(() => (this.agenciesLoading = false))
  },
  data () {
    return {
      search: this.$route.query.s || '',
      agency: {
        editing: null,
        cached: null,
        updated: false,
        canSave: false,
        isSaving: false
      },
      agenciesLoading: false,
      statusOptions: statusOptions,
      agencyTypeOptions: agencyTypeOptions,
      headers: [
        { text: '#', value: 'index', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'tag' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      rules: {
        isRequired: value => this.$validator.isRequired(value)
      }
    }
  },
  methods: {
    editMode (agency) {
      this.agency.canSave = false
      this.agency.updated = false
      this.agency.editing = agency._id
      this.agency.cached = Object.assign({}, agency)
      delete this.agency.cached.created // removes the created timestamp
      delete this.agency.cached.modified // removes the modified timestamp
    },
    updateAgency () {
      if (this.$validator.isRequired(this.agency.cached.name) !== true) return
      this.agency.isSaving = true
      this.$store.dispatch(AGENCY_UPDATE, this.agency.cached)
        .then(() => {
          this.agency.updated = 'Partner has been successfully updated.'
        })
        .finally(() => {
          this.agency.canSave = false
          this.agency.editing = null
          this.agency.cached = null
          this.agency.isSaving = false
        })
    },
    cancelEdit () {
      this.agency.canSave = false
      this.agency.editing = null
      this.agency.cached = null
    }
  },
  computed: {
    ...mapGetters(['agencies'])
  }
}
</script>
